import React, { useState } from 'react';
import { InfoWindow, Marker } from "react-google-maps";
import Panel from './Panel';

export default ({ marker, onClick, hideLabel=false }) => {
    const [showLabel, setShowLabel] = useState(false);
    return (
        <Marker
            key={marker.id}
            position={marker.position}
            icon={{
                url: '/_resources/themes/base/dist/images/svgs/map-pointer.svg',
            }}
            onClick={() => setShowLabel(!showLabel)}
        >
            {showLabel && !hideLabel && (
                <InfoWindow>
                    {/* <h4>{marker.label}</h4> */}
                    <Panel
                    panel={marker.panelInfo}
                    // splitViewPanel={isSplitView}
                />
                </InfoWindow>
            )}
        </Marker>
    )
}
